import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useMutation } from '@tanstack/react-query';
import { useQueryCacheTagHelpers } from '../utils/useQueryCacheTagHelpers.js';
import { useWoody } from '../../woody/woody.js';
import { toast } from '../../store/alerts.js';
import { withConfirmation } from '../../queries/utils/withConfirmation.js';
import { removeItemsWithProvidedIdFromHistory } from '../../app/stores/userNavigationHistoryStore.js';

const useMutationTagDelete = () => {
  const { client } = useWoody();
  const { track } = useAnalytics();
  const { deleteCachedTag } = useQueryCacheTagHelpers();
  return withConfirmation(useMutation({
    mutationFn: async (tagId) => {
      return client.v2({
        endpoint: "/v2/tags/{tagId}",
        params: {
          tagId
        }
      }, {
        method: "delete"
      });
    },
    onMutate: async (tagId) => {
      return deleteCachedTag(tagId);
    },
    onError: (_e, _v, context) => {
      toast({
        content: "Something went wrong while deleting the tag. Please try again."
      });
      context?.resetCacheToPreOptimisticState();
      context?.invalidateQueries();
    },
    onSuccess: (_, tagId) => {
      track(AnalyticsEvents.DeletedTag, {
        tagId
      });
      removeItemsWithProvidedIdFromHistory(tagId);
    }
  }), () => ({
    title: "Delete tag - Are you sure?",
    content: "Are you sure you want to delete this tag? This action cannot be undone.",
    confirmLabel: "Yes, Delete",
    cancelLabel: "Cancel",
    confirmButtonProps: {
      variant: "danger"
    }
  }));
};

export { useMutationTagDelete };
//# sourceMappingURL=useMutationTagDelete.js.map
